export const currentUserLabel = 'Вы';
export const participantLabel = 'Участник встречи';
